"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMediaQuery = exports.ThemeProvider = exports.makeStyles = exports.authTheme = exports.defaultTheme = exports.NORTHSTAR_COLORS = void 0;
var color_1 = require("../config/color");
Object.defineProperty(exports, "NORTHSTAR_COLORS", { enumerable: true, get: function () { return color_1.NORTHSTAR_COLORS; } });
var default_1 = require("./default");
Object.defineProperty(exports, "defaultTheme", { enumerable: true, get: function () { return default_1.theme; } });
Object.defineProperty(exports, "authTheme", { enumerable: true, get: function () { return default_1.authTheme; } });
var core_1 = require("@material-ui/core");
Object.defineProperty(exports, "makeStyles", { enumerable: true, get: function () { return core_1.makeStyles; } });
Object.defineProperty(exports, "ThemeProvider", { enumerable: true, get: function () { return core_1.ThemeProvider; } });
Object.defineProperty(exports, "useMediaQuery", { enumerable: true, get: function () { return core_1.useMediaQuery; } });
//# sourceMappingURL=index.js.map